import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { UrlBuilder } from '../core';
import { UserPermissionsStorage } from '../user-permissions/user-permissions-storage';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { findProtocolId } from '../shared/route-helpers';

@Injectable()
export class CanSponsorViewKitInventoryGuard implements CanActivate {

    constructor(
        private readonly urlBuilder: UrlBuilder,
        private readonly userPermissionsStorage: UserPermissionsStorage,
    ) { }

    public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        const protocolId = findProtocolId(route);

        const studyPermissions$ = this.userPermissionsStorage.getPermissionsByStudy(protocolId);

        return studyPermissions$.pipe(
            map((studyPermissions) => {
                if (!studyPermissions) {
                    this.urlBuilder
                        .esa()
                        .navigate();
                    return false;
                }

                if (studyPermissions.has('KitInventoryandExpirationReport')) {
                    return true;
                }

                this.urlBuilder
                    .esa()
                    .navigate();

                return false;
            })
        );
    }
}